import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type Decision } from '../../api/decision';

export function ApprovalDashboardPage() {
  const [decisions, setDecisions] = useState<Decision[]>([]);

  useEffect(() => {
    void decisionApi.listDecisions((getWorkspaceId() ?? '')).then(setDecisions);
  }, []);

  const pending = decisions.filter((d) => d.status === 'pending_approval');

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Approval Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Human approval queue for AI recommendations and autonomous execution.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 space-y-3">
        {pending.map((d) => (
          <div key={d.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="font-medium">{d.title}</p>
            <p className="text-xs text-slate-500">{d.domain} · {d.execution_mode} · {(d.confidence * 100).toFixed(0)}% confidence</p>
            {d.explanation && <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{d.explanation}</p>}
          </div>
        ))}
        {pending.length === 0 && <p className="text-sm text-slate-500">No pending approvals.</p>}
      </div>
    </div>
  );
}
